import { formatApi } from '@/api/baseApi';

/**
 * 查询「验收失败」原因选项
 * 与 PC 端 if-web/src/api/operateData/acceptanceApi.js 保持一致
 */
export async function rejectSelect() {
  const result = await formatApi({
    Action: 'Nbroker',
    Method: 'UrlProxy',
    NbrokerData: {
      context: {
        service_name: 'ServerDirect',
        method_name: 'reject_select',
      },
      args: {},
    },
    ServiceUrl: 'http://ibroker-serveroperation:8080/nBroker/api/v1/task',
    SystemId: '2',
  });
  if (result?.data?.status !== 0) {
    throw new Error(result?.data?.msg || '查询验收失败原因选择框异常');
  }
  return result.data.data;
}

/**
 * 查询「延迟验收」原因选项
 * 与 PC 端 if-web/src/api/operateData/acceptanceApi.js 保持一致
 */
export async function delaySelect() {
  const result = await formatApi({
    Action: 'Nbroker',
    Method: 'UrlProxy',
    NbrokerData: {
      context: {
        service_name: 'ServerDirect',
        method_name: 'delay_select',
      },
      args: {},
    },
    ServiceUrl: 'http://ibroker-serveroperation:8080/nBroker/api/v1/task',
    SystemId: '2',
  });
  if (result?.data?.status !== 0) {
    throw new Error(result?.data?.msg || '查询延迟原因选择框异常');
  }
  return result.data.data;
}
